import { rem } from "@certn/cascadia";
import { css } from "@emotion/css";
import { transparentize } from "color2k";
import { useMemo } from "react";

import { ScrollContainerProps } from "./ScrollContainer";
import { useFocusStyle } from "../../components/utils";
import { useColors } from "../../hooks/useColors";

export function useScrollContainerStyles(props: ScrollContainerProps) {
  const {
    background = "background-base",
    padding = "space-4",
    maxHeight,
  } = props;
  const colors = useColors();
  const getFocusStyle = useFocusStyle();

  return useMemo(() => {
    const backgroundColor = colors[background];
    const transparentColor = transparentize(backgroundColor, 1);

    return {
      container: css({
        position: "relative",
      }),
      contents: css(
        {
          maxHeight,
          overflow: "scroll",
          padding: rem(padding),
        },
        getFocusStyle("focus-action")
      ),
      topGradient: css(styles.gradient, {
        top: 0,
        backgroundImage: `linear-gradient(0deg, ${transparentColor} 0%, ${backgroundColor} 100%)`,
      }),
      bottomGradient: css(styles.gradient, {
        bottom: 0,
        backgroundImage: `linear-gradient(180deg, ${transparentColor} 0%, ${backgroundColor} 100%)`,
      }),
    };
  }, [background, padding, maxHeight, colors, getFocusStyle]);
}

const styles = {
  gradient: css({
    position: "absolute",
    pointerEvents: "none",
    width: "100%",
    height: "24px",
    transition: "opacity 200ms",
    opacity: 0,
  }),
};
